import { BaSeLoading, BaSeParagraph, BaSeSmall1, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { useReport } from '../hook/useReport';
import {
  Container,
  ContentField,
  ContentMore,
  Header,
} from './characteristics-entrepreneur-style';
import RowInfo from './row-info';

// eslint-disable-next-line sonarjs/cognitive-complexity
function CharacteristicsEntrepreneur() {
  const { getRouteParam } = Sebrae.useSebraeRouter();
  const { getStepData, laoding } = useReport();
  const [response, setResponse] = React.useState({});
  const [erro, setErro] = React.useState();

  React.useEffect(() => {
    getStepData({
      cpf: getRouteParam('cpf'),
      step: 'CARACTERISTICAS_COMPORTAMENTO_EMPREENDER',
    })
      .then((response) => {
        setResponse(response);
      })
      .catch((error) => {
        setErro(error);
        console.log('deu erro', error);
      });
  }, [getRouteParam, getStepData]);

  if (laoding) {
    return (
      <Header>
        <BaSeLoading
          backgroundColor="#fff"
          description=""
          lightMode="default"
          shadowLevel={0}
          spinnerColor=""
          spinnerSize={24}
          text="Carregando…"
          textColor=""
        />
      </Header>
    );
  }

  if (!response?.showStep) {
    return <> </>;
  }

  const COLOR_MORE = '#387F3A';
  const COLOR_LESS = '#B62A7E';
  return erro ? (
    <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
      Erro para carregar informações do relatório
    </BaSeParagraph>
  ) : (
    <div>
      <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
        CARACTERÍSTICAS DO COMPORTAMENTO EMPREENDEDOR
      </BaSeParagraph>
      <Container>
        <ContentMore>
          <Header color={COLOR_MORE}>
            <BaSeSmall1 color={BaSeTheme.colors.defaultColors.white}>
              MAIS POTENCIALIZADOS
            </BaSeSmall1>
          </Header>
          <ContentField>
            <RowInfo
              title={response?.data?.morePontentiated?.primary}
              description={response?.data?.morePontentiated?.descPrimary}
              color={COLOR_MORE}
              typeIcon={'up'}
            />
            <RowInfo
              title={response?.data?.morePontentiated?.secondary}
              description={response?.data?.morePontentiated?.descSecondary}
              color={COLOR_MORE}
              typeIcon={'up'}
            />
            <RowInfo
              title={response?.data?.morePontentiated?.tertiary}
              description={response?.data?.morePontentiated?.descTertiary}
              color={COLOR_MORE}
              typeIcon={'up'}
            />
          </ContentField>
        </ContentMore>

        <ContentMore>
          <Header color={COLOR_LESS}>
            <BaSeSmall1 color={BaSeTheme.colors.defaultColors.white}>
              MENOS POTENCIALIZADOS
            </BaSeSmall1>
          </Header>
          <ContentField>
            <RowInfo
              title={response?.data?.lessPontentiated?.primary}
              description={response?.data?.lessPontentiated?.descPrimary}
              color={COLOR_LESS}
              typeIcon={'down'}
            />
            <RowInfo
              title={response?.data?.lessPontentiated?.secondary}
              description={response?.data?.lessPontentiated?.descSecondary}
              color={COLOR_LESS}
              typeIcon={'down'}
            />
            <RowInfo
              title={response?.data?.lessPontentiated?.tertiary}
              description={response?.data?.lessPontentiated?.descTertiary}
              color={COLOR_LESS}
              typeIcon={'down'}
            />
          </ContentField>
        </ContentMore>
      </Container>
    </div>
  );
}

export default CharacteristicsEntrepreneur;
